import React from 'react'
import { SectionHeader, Header2, Text } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import PackageOptions from './PackageOptions'

const ChoosePackage = () => {
  return (
    <div className="choose-package-container">
      <SectionHeader margin="0 0 9px 0" small>
        Step 3
      </SectionHeader>
      <Header2 margin="0 0 15px 0">Choose a package</Header2>
      <Text
        className="package-text"
        color={gsColors.meredithGrey}
        lineHeight="144%"
        margin="0 0 37px"
      >
        We&apos;ll add tax & gratuity to the price before checkout. Packages do
        not expire and are available in all markets except the Hamptons.
      </Text>
      <PackageOptions />
      <div className="divider choose-package-divider" />
    </div>
  )
}

export default ChoosePackage
